module.exports = __webpack_public_path__ + "media/2.a28be108.mp3";